import './Toast.pcss';

export type ToastProps = {
    content: HTMLElement | string;
};

export default class Toast extends HTMLElement {
    #visibleTimeout: undefined | NodeJS.Timeout;

    #replaceable = false;

    #nextToast: Toast | null = null;

    constructor(content?: HTMLElement | string) {
        super();

        this.setAttribute('data-testid', 'toast-notification');

        if (typeof content === 'string') {
            this.innerHTML = content;
        }

        if (content instanceof HTMLElement) {
            this.append(content);
        }
    }

    public replaceWith(element: Toast): void {
        this.#nextToast = element;
        if (!this.#replaceable) return;
        this.#hideAndRemove();
    }

    protected connectedCallback(): void {
        this.addEventListener('animationend', () => {
            this.removeAttribute('show');
            setTimeout(() => this.#openForReplacement(), 1000);
            this.#visibleTimeout = setTimeout(() => this.#hideAndRemove(), 5000);
        });

        this.toggleAttribute('show', true);
    }

    #openForReplacement(): void {
        this.#replaceable = true;

        if (!this.#nextToast) return;

        if (this.#visibleTimeout) {
            clearTimeout(this.#visibleTimeout);
        }

        this.#hideAndRemove();
    }

    #hideAndRemove(): void {
        this.toggleAttribute('hide', true);
        this.addEventListener('animationend', () => this.#removeToast());
    }

    #removeToast(): void {
        if (this.#nextToast === null) {
            this.remove();
            return;
        }

        const parent = this.parentElement;
        this.remove();
        parent?.append(this.#nextToast);

        this.#nextToast = null;
    }
}

if (!window.customElements.get('nh-toast')) {
    window.customElements.define('nh-toast', Toast);
}
